// extracted by mini-css-extract-plugin
export default {"HeaderEditorContainer":"HeaderEditor-module__HeaderEditorContainer__lV4haeX"};